import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,Link} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input, Typography,Tooltip } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import PercentageBadge from '../../components/percentageBadge'

const { Option } = Select;
const { TextArea } = Input;

const Batches = () => {

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [gameType, setGameType] = useState(local_game_type)
  const [gameLevel, setGameLevel] = useState('')
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [batchesData, setBatchesData] = useState([])
  const [ageGroups, setAgeGroups] = useState([])
  const [ageGroupId, setageGroupId] = useState('')
  const [month, setMonth] = useState(moment().format('MM'))
  const [year, setYear] = useState(moment().format('YYYY'))

  useEffect(() => {
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
  }, [selectedVenueId,cityId,gameType]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getBatchDetails()
    }
  }, [selectedVenueId,cityId,gameType,gameLevel,ageGroupId,month,year]); 

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
      setAgeGroups(response.age_groups)
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const getBatchDetails = () => {
    const monthParam = year && month ? `${year}-${month}` : ''
    getData(`/business/get_batches_summary/?venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}&game_level=${gameLevel}&age_group_id=${ageGroupId}&month=${monthParam}`)
    .then(response =>{
      setBatchesData(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }


  const columns = batchesData.length > 0 ? 
    [
      ...Object.keys(batchesData[0]).filter(key => key !== 'venue_id').map(key => ({
        title: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),  
        dataIndex: key,
        key: key,
        align: key !== 'venue' && 'center',
        sorter: key !== 'venue' ? (a, b) => a[key] - b[key] : false,
        render: key === 'venue' ? 
                  (text, record) => {
                    // const cleanedText = text.replace(/Sporthood/i, "").trim();
                    const venuename = text.length > 30 ? `${text.slice(0, 30)}...` : text;
                    const level = gameLevel || 'All';
                    return(
                      <Tooltip title={record.venue}>
                        <Link to={`/batches/utilization/${record.venue_id}/${level}`} className='venueTitle'>
                          {venuename}
                        </Link>
                      </Tooltip>
                    )
                  }
                : 
                key == 'utilization' ?
                  (text, record) => {
                    const value = record.utilization
                    return(
                      <PercentageBadge value={value} />
                    )
                  }
                :
                key == '<30%' || key == '30-50%' || key == '50-80%' || key == '>80%' ?
                text => 
                  <span style={{padding:'5px',borderRadius:'5px',color:key == '<30%' ? '#FF4D4D': key == '30-50%' ? '#FF8C00' : key == '50-80%' ? '#DAA520' : '#228B22' ,fontWeight:600}}>{text}</span>
                :

                text => text
        })),
      {
        title: '',
        dataIndex: 'venue_id',
        render: (value) => {
          const level = gameLevel || 'All';
          return(
            <Link to={`/batches/utilization/${value}/${level}`} className='venueTitle'>
              <ArrowRightOutlined/>
            </Link>
            )
        }
      }
    ]
  : 
    [];

  const isCurrentMonth = month === moment().format('MM') && year === moment().format('YYYY');

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

          <Styled.TopDiv>    
          <Styled.SelectorContainer style={{flexWrap:'wrap', gap: '10px'}}>

            {cities.length > 1 &&
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }
            
            {venuelist && venuelist.length > 0 &&
              <Styled.Selector> 
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

            <Styled.Selector>
              <span className='indicatorText'>Program</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameType}
                  value = {gameType}
                  bordered={false}
                >
                  <Option value="8"> Football Academy </Option>
                  <Option value="10"> Badminton Academy </Option>
                  <Option value="65"> Swimming Academy </Option>
                  <Option value="44"> Tennis Academy </Option>

                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Skill Level</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameLevel}
                  value = {gameLevel}
                  bordered={false}
                > 
                  <Option value=""> All </Option>
                  <Option value="Beginner"> Beginner </Option>
                  <Option value="Advanced"> Advanced </Option>
                  <Option value="Elite"> Elite </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Age Group</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setageGroupId}
                  value = {ageGroupId}
                  bordered={false}
                > 
                  <Option value=""> All </Option>
                  {ageGroups && ageGroups.map((ageGroup,index)=>(
                      ageGroup.name != 'Adults' &&
                      <Option value={ageGroup.id}> {ageGroup.name} </Option>
                    ))
                  }
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Month</span>
              <Select
                className = 'mainSelector'
                style={{width: 150}}
                onChange={setMonth}
                value = {month}
                bordered={false}
              >
                <Option value="12"> December </Option>
                <Option value="11"> November </Option>
                <Option value="10"> October </Option>
                <Option value="09"> September </Option>
                <Option value="08"> August </Option>
                <Option value="07"> July </Option>
                <Option value="06"> June </Option>
                <Option value="05"> May </Option>
                <Option value="04"> April </Option>
                <Option value="03"> March </Option>
                <Option value="02"> February </Option>
                <Option value="01"> January </Option>
              </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Year</span>
              <div className = 'mainSelector' style={{width: 110}}>
                <DatePicker defaultValue={moment(year, 'YYYY')} onChange={(d, s)=>setYear(s)} bordered={false} picker="year" />
              </div>
            </Styled.Selector>

          </Styled.SelectorContainer>
        </Styled.TopDiv>

        <Styled.Header>          
          <span> Batch Overview</span>
        </Styled.Header>
        {isCurrentMonth && (
          <Typography.Text type="primary" style={{ fontSize: 12}}>
            * <b>Customers</b> count include only those assigned to a <b>batch</b> and consist of currently <b>active</b> and <b>payment due</b> customers within 14 days after expiry.
          </Typography.Text>
        )}
        <Table
          className="ant-table-thead table_container"
          rowKey="id"
          columns={columns}
          dataSource={batchesData}
          pagination={false}
          summary={() => {
            const totalRow = {};
            const excludeKeys = ['venue', 'venue_id'];
            const totalCount = batchesData.length;

            if (totalCount > 0) {
              let totalCustomers = 0;
              let totalCapacity = 0;

              batchesData.forEach(item => {
                totalCustomers += item.customers;
                totalCapacity += item.capacity;
              });

              Object.keys(batchesData[0]).forEach((key) => {
                if (!excludeKeys.includes(key)) {
                  const isNumber = typeof batchesData[0][key] === 'number';
                  if (isNumber) {
                    const total = batchesData.reduce((sum, item) => {
                      return sum + item[key];
                    }, 0);

                    if (key === 'utilization') {
                      const utilizationAvg = (totalCustomers / totalCapacity) * 100;
                      totalRow[key] = `${utilizationAvg.toFixed(1)}%`;
                    } else {
                      totalRow[key] = total;
                    }
                  }
                }
              });
            }

            return (
              <Table.Summary.Row>
                {columns.map((col, index) => {
                  const key = col.dataIndex;

                  if (index === 0) {
                    return (
                      <Table.Summary.Cell key={key}><b>Total</b></Table.Summary.Cell>
                    );
                  }

                  if (key === 'venue_id') {
                    return <Table.Summary.Cell key={key} />;
                  }

                  return (
                    <Table.Summary.Cell key={key} align="center">
                      {totalRow.hasOwnProperty(key) ? (
                        <b>{totalRow[key]}</b>
                      ) : ''}
                    </Table.Summary.Cell>
                  );
                })}
              </Table.Summary.Row>
            );
          }}
         />

      </Styled.MainContainer>
    </Spin>
  );
}

export default Batches;